module.exports = __webpack_public_path__ + "img/logo.15b1da3f.png";